/**
 * @module Utilities/Flux
 * @desc Flux helper funtions
 */

import { produce } from 'immer';

import type { ActionPayload, ActionsMapReducer } from './flux';
import type { Reducer } from 'redux';

/**
 * Streamlines the implementation of reducers abstracting the immer implementation to
 * ensure the state immutability
 */
export function createReducer<State>(
  actionsMap: ActionsMapReducer<State>,
  defaultState: State,
): Reducer<State, ActionPayload> {
  return (state = defaultState, action: ActionPayload) =>
    produce(state, (draft: State) => {
      const fn = actionsMap[action.type];

      if (fn) {
        return fn(draft, action);
      }

      return draft;
    });
}
